import * as Rest from 'src/constants/rest'
import http from 'src/utils/Http'

type FetchReturn = Promise<any>

export function getTokenToSign(): Promise<{ token: string }> {
  return http
    .post({
      url: Rest.TOKEN,
      token: true,
      params: {}
    })
    .then(res => ({
      token: res.token
    }))
}

export function startSesion(signedToken: string): FetchReturn {
  return http.post({
    url: Rest.LOGIN_TOKEN,
    token: true,
    params: {
      signedToken
    }
  })
}

export function endSession(): FetchReturn {
  return http.post({
    url: Rest.LOGOUT_LEXNET,
    token: true,
    keepalive: true,
    params: {}
  })
}

export function getUser(): FetchReturn {
  return http.get({
    url: Rest.ME,
    token: true
  })
}

export function saveSelectedUser(userId: number | null | undefined): FetchReturn {
  return http.post({
    url: Rest.SELECT_USER,
    token: true,
    keepalive: true,
    params: {
      userId
    }
  })
}

export function saveDefaultUser(userId: number | null | undefined): FetchReturn {
  return http.post({
    url: Rest.DEFAULT_USER,
    token: true,
    keepalive: true,
    params: {
      userId
    }
  })
}
